module.exports = __webpack_public_path__ + "media/conmex/peticiones-fc66fc40.png";